(() => {
  const NIKA_IMAGE =
    'https://miyabiya-japan.com/cdn/shop/files/2025-11-1423.30.51.png?v=1763137890&width=240';
  const isEnglishPage = () =>
    !/^\/ja(\/|$)/i.test(window.location.pathname) &&
    (/^en/i.test(document.documentElement.lang || '') || !/^\/ja(\/|$)/i.test(window.location.pathname));
  const NIKA_SEARCH_URL = () =>
    (isEnglishPage() ? '/pages/character-search?q=Luffy' : '/ja/pages/character-search?q=%E3%83%AB%E3%83%95%E3%82%A3');

  const isNikaText = (value) => /ニカ|ギア5|Gear\s*5|Luffy|ルフィ/i.test(String(value || ''));

  const toEnglishKeyword = (value) => {
    const text = String(value || '').trim();
    const map = {
      '五条悟': 'Satoru Gojo',
      '呪術廻戦': 'Jujutsu Kaisen',
      '伏黒恵': 'Megumi Fushiguro',
      '夏油傑': 'Suguru Geto',
      '虎杖悠仁': 'Yuji Itadori',
      '七海建人': 'Kento Nanami',
      '初音ミク': 'Hatsune Miku',
      'アーニャ': 'Anya',
      '爆豪勝己': 'Katsuki Bakugo',
      'ヒロアカ': 'My Hero Academia',
      'ニカ（ルフィ）': 'Gear 5 Luffy',
      'ニカ': 'Gear 5 Luffy',
      'ルフィ': 'Luffy',
      'ブルーロック': 'Blue Lock',
      '鬼滅の刃': 'Demon Slayer',
      '関連キーワード': 'Related Keywords',
    };
    return map[text] || text;
  };

  const setNikaImage = (image) => {
    if (!(image instanceof HTMLImageElement)) return;
    image.src = NIKA_IMAGE;
    image.srcset = '';
    image.alt = isEnglishPage() ? 'Gear 5 Luffy' : 'ギア5ルフィ / ニカ';
    image.style.setProperty('object-fit', 'contain', 'important');
    image.style.setProperty('background-color', '#f7f2ee', 'important');
  };

  const ensurePolishStyle = () => {
    if (document.getElementById('miyabiya-character-search-polish-style')) return;
    const style = document.createElement('style');
    style.id = 'miyabiya-character-search-polish-style';
    style.textContent = `
      body:has(.mcs-page) .mcs-page.is-searching .mcs-pickup,
      body:has(.mcs-page) .mcs-page.is-searching .mcs-guide,
      body:has(.mcs-page) .mcs-page.is-searching .mcs-tabs,
      body:has(.mcs-page) .mcs-page.is-searching .mcs-hero > .mcs-row {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
      }

      body:has(.mcs-page) .mcs-page.is-searching .mcs-main {
        gap: 8px !important;
        align-content: start !important;
      }

      body:has(.mcs-page) .mcs-page.is-searching .mcs-layout {
        align-items: start !important;
      }

      body:has(.mcs-page) .mcs-page.is-searching .mcs-hero {
        margin-bottom: 0 !important;
        padding-bottom: 0 !important;
      }

      body:has(.mcs-page) .mcs-page.is-searching .mcs-section {
        display: flex !important;
        align-items: center !important;
        min-height: 0 !important;
        height: auto !important;
        margin: 8px 0 8px !important;
        padding: 0 !important;
      }

      body:has(.mcs-page) .mcs-release {
        grid-template-columns: 44px minmax(0, 1fr) !important;
      }

      body:has(.mcs-page) .mcs-calendar-icon {
        display: none !important;
      }
    `;
    document.head.append(style);
  };

  const polishNikaImages = () => {
    const root = document.querySelector('.mcs-page');
    if (!root) return;

    root.querySelectorAll('.mcs-rank').forEach((rank) => {
      const label = rank.textContent || '';
      if (!isNikaText(label)) return;
      const meta = rank.querySelector('.mcs-meta')?.textContent || '';
      if (!/ONE\s*PIECE|ワンピース/i.test(meta) && !isNikaText(label)) return;
      rank.setAttribute('href', NIKA_SEARCH_URL());
      const item = rank.querySelector('.mcs-item');
      if (item) item.textContent = isEnglishPage() ? 'Gear 5 Luffy' : 'ルフィ';
      setNikaImage(rank.querySelector('img'));
    });

    root.querySelectorAll('.mcs-pickup, .mcs-character-pickup').forEach((card) => {
      if (!isNikaText(card.textContent || '')) return;
      setNikaImage(card.querySelector('img'));
    });
  };

  const localizeTopCharacters = () => {
    if (!isEnglishPage()) return;
    const root = document.querySelector('.mcs-page');
    if (!root) return;

    root.querySelectorAll('.mcs-card.is-top5 .mcs-rank, .mcs-rail .mcs-rank').forEach((rank) => {
      const item = rank.querySelector('.mcs-item');
      const meta = rank.querySelector('.mcs-meta');
      const img = rank.querySelector('img');
      if (item) {
        const nextItem = toEnglishKeyword(item.textContent);
        if (nextItem !== item.textContent.trim()) item.textContent = nextItem;
      }
      if (meta) {
        const nextMeta = toEnglishKeyword(meta.textContent);
        if (nextMeta !== meta.textContent.trim()) meta.textContent = nextMeta;
      }
      const label = item?.textContent?.trim();
      if (img && label) img.alt = label;
      if (label) rank.href = `/pages/character-search?q=${encodeURIComponent(label)}`;
    });

    root.querySelectorAll('.mcs-row .mcs-chip, .mcs-card .mcs-chip').forEach((chip) => {
      const next = toEnglishKeyword(chip.textContent);
      if (next !== chip.textContent.trim()) {
        chip.textContent = next;
        chip.href = `/pages/character-search?q=${encodeURIComponent(next)}`;
      }
    });
  };

  const polishReleaseRail = () => {
    const root = document.querySelector('.mcs-page');
    if (!root) return;
    const releaseCard = Array.from(root.querySelectorAll('.mcs-card')).find((card) => {
      const title = card.querySelector('.mcs-title')?.textContent || '';
      return /今後の発売予定|Upcoming/.test(title);
    });
    const list = releaseCard?.querySelector('.mcs-list.release');
    if (!releaseCard || !list) return;

    list.querySelectorAll('.mcs-calendar-icon').forEach((icon) => icon.remove());
    list.querySelectorAll('.mcs-release').forEach((item) => {
      item.style.setProperty('grid-template-columns', '44px minmax(0, 1fr)', 'important');
    });

    if (isEnglishPage()) {
      list.querySelectorAll('.mcs-calendar-icon').forEach((icon) => icon.remove());
      list.querySelectorAll('.mcs-release').forEach((item) => {
        item.href = '/pages/release-calendar';
        const date = item.querySelector('b');
        const label = item.querySelector('.mcs-item');
        const meta = item.querySelector('.mcs-meta');
        if (date && /確認/.test(date.textContent || '')) date.textContent = 'Check';
        if (label && /発売予定を取得中|カレンダー/.test(label.textContent || '')) label.textContent = 'Loading upcoming releases';
        if (meta && /カレンダー|発売予定/.test(meta.textContent || '')) meta.innerHTML = '<strong>Calendar</strong>';
        if (/鬼滅の刃|発売予定|フィギュアーツZERO|煉獄|童磨/.test(item.textContent || '')) item.remove();
      });
      return;
    }

    const fallbackRows = [
      {
        date: '06/中',
        title: 'フィギュアーツZERO 鬼滅の刃 童磨',
        status: '発売予定',
        price: '14,300円',
        url: '/ja/pages/release-calendar',
      },
      {
        date: '06/中',
        title: '鬼滅の刃 炎柱・煉獄杏寿郎 ノンスケールフィギュア',
        status: '発売予定',
        price: '6,800円',
        url: '/ja/pages/release-calendar',
      },
    ];

    fallbackRows.forEach((row) => {
      if (list.querySelectorAll('.mcs-release').length >= 5) return;
      if ((list.textContent || '').includes(row.title)) return;
      const link = document.createElement('a');
      link.className = 'mcs-release';
      link.href = row.url;
      link.style.setProperty('grid-template-columns', '44px minmax(0, 1fr)', 'important');
      link.innerHTML = `<b>${row.date}</b><span><span class="mcs-item">${row.title}</span><span class="mcs-meta"><strong>${row.status}</strong> ${row.price}</span></span>`;
      list.append(link);
    });
  };

  const polishCharacterSearchSpacing = () => {
    const root = document.querySelector('.mcs-page.is-searching');
    if (!root) return;
    ensurePolishStyle();

    root.querySelectorAll('.mcs-pickup, .mcs-guide, .mcs-tabs, .mcs-hero > .mcs-row').forEach((node) => {
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('height', '0', 'important');
      node.style.setProperty('min-height', '0', 'important');
      node.style.setProperty('margin', '0', 'important');
      node.style.setProperty('padding', '0', 'important');
      node.style.setProperty('overflow', 'hidden', 'important');
    });

    root.querySelector('.mcs-main')?.style.setProperty('gap', '8px', 'important');
    root.querySelector('.mcs-main')?.style.setProperty('align-content', 'start', 'important');
    root.querySelector('.mcs-layout')?.style.setProperty('align-items', 'start', 'important');
    root.querySelector('.mcs-hero')?.style.setProperty('padding-bottom', '0', 'important');
    root.querySelector('.mcs-hero')?.style.setProperty('margin-bottom', '0', 'important');
    const section = root.querySelector('.mcs-section');
    if (section) {
      section.style.setProperty('min-height', '0', 'important');
      section.style.setProperty('height', 'auto', 'important');
      section.style.setProperty('margin', '8px 0 8px', 'important');
      section.style.setProperty('padding', '0', 'important');
      section.style.setProperty('align-items', 'center', 'important');
    }
  };

  const run = () => {
    localizeTopCharacters();
    polishNikaImages();
    polishReleaseRail();
    polishCharacterSearchSpacing();
  };

  run();
  document.addEventListener('DOMContentLoaded', run);
  window.setTimeout(run, 700);
  window.setTimeout(run, 1800);
  window.setTimeout(run, 3200);
  window.setTimeout(run, 5000);
})();
